<template>
  <div>
    <b-toast :id="idToast" :variant="variant" solid>
      <div slot="toast-title" class="d-flex flex-grow-1 align-items-baseline">
        <strong class="mr-auto">{{titleMsg}}</strong>
      </div>
      {{message}}
    </b-toast>
  </div>
</template>
<script>
  export default {
    props: ['variant', 'message', 'titleMsg', 'idToast']
  }
</script>



// WEBPACK FOOTER //
// src/components/layouts/toastVue.vue